/** Mirror Backend ``issue_type_ref_for_slug`` (kryspace_write_service). */

const PLATFORM_ISSUE_SLUGS = new Set([
  'prime_ops',
  'kryspace_ops',
  'krysalis_backend_ops',
  'krysalis_frontend_ops',
  'krysalis_krybot_ops',
]);

export function issueTypeRefForSlug(slug: string): string {
  const normalized = slug.trim();
  if (normalized === 'kryspace_ops') {
    return 'pt-sp-issue';
  }
  if (PLATFORM_ISSUE_SLUGS.has(normalized) || normalized.endsWith('_ops')) {
    return 'pt-po-issue';
  }
  return 'pt-bsc-issue';
}
